// Redux Actions
import { POST } from 'utils/fetchWrappers';
import {
    API_DOWNLOAD_BULK_PAYMENT_LINK_FILE,
    API_DOWNLOAD_BULK_PAYMENT_LINK_PRE_FILLED_FILE,
    API_FETCH_RECENT_BULK_PAYMENT_LINK,
    API_UPLOAD_BULK_PAYMENT_LINK_FILE,
} from 'utils/API/apiUrls';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import {
    downloadBulkPaymentLinkPreFilledFileCSV,
    downloadFile,
} from '../../../utils/helperMethods';
import * as bulkPaymentLinkActions from './BulkPaymentLink.actions';

// constants
import {
    DOWNLOAD_BULK_PAYMENT_LINK_REQUEST,
    GET_LINK_ID_FOR_PRE_FILLED_FILE_REQUEST,
    GET_RECENT_BULK_PAYMENT_LINK_REQUEST,
    UPLOAD_BULK_PAYMENT_LINK_REQUEST,
} from './BulkPaymentLink.constants';

// Library
import { toast } from 'react-toastify';
import { takeLatest, put, call } from 'redux-saga/effects';

export function* downloadBulkPaymentLinkPreFilledFile(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;

        let { data } = yield call(
            POST,
            API_DOWNLOAD_BULK_PAYMENT_LINK_PRE_FILLED_FILE,
            payload
        );

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            data = {
                linkDataId: data.linkDataId,
                linkName: payload.linkName,
            };

            downloadBulkPaymentLinkPreFilledFileCSV(
                data.linkDataId,
                data.linkName
            );
        } else if (data && data.errorMessage) {
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data.errorMessage
            ? data.errorMessage
            : 'Something went wrong. Please try again after sometime.';
        toast.error(errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchRecentBulkPaymentLink(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;

        const requestPayload = {
            fileProcessEnum: 'BULK_PAYLINK_FILE_UPLOAD',
            ...payload,
        };

        const { data } = yield call(
            POST,
            API_FETCH_RECENT_BULK_PAYMENT_LINK,
            requestPayload
        );

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                bulkPaymentLinkActions.fetchRecentBulkPaymentLinkSuccess(data)
            );
        } else if (data && data.errorMessage) {
            yield put(
                bulkPaymentLinkActions.fetchRecentBulkPaymentLinkFailed({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;

        const errorMessage = data.errorMessage
            ? data.errorMessage
            : 'Something went wrong. Please try again after sometime.';

        bulkPaymentLinkActions.fetchRecentBulkPaymentLinkFailed({
            error: errorMessage,
        });

        toast.error(errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

export function* uploadBulkPaymentLinkFile(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;

        const { data } = yield call(
            POST,
            API_UPLOAD_BULK_PAYMENT_LINK_FILE,
            payload,
            {
                'Content-Type': 'multipart/form-data;',
            },
            true
        );

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            toast.info('File Uploaded Successfully');
        } else if (data && data.errorMessage) {
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data.errorMessage
            ? data.errorMessage
            : 'Something went wrong. Please try again after sometime.';
        toast.error(errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

export function* downloadBulkPaymentLinkFile(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;

        const { data } = yield call(
            POST,
            API_DOWNLOAD_BULK_PAYMENT_LINK_FILE,
            payload
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            downloadFile(data.fileUrl);
        } else if (data && data.errorMessage) {
            toast.error(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data.errorMessage
            ? data.errorMessage
            : 'Something went wrong. Please try again after sometime.';
        toast.error(errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* bulkPaymentLinkSaga(actions) {
    yield takeLatest(
        GET_LINK_ID_FOR_PRE_FILLED_FILE_REQUEST,
        downloadBulkPaymentLinkPreFilledFile
    );
    yield takeLatest(
        GET_RECENT_BULK_PAYMENT_LINK_REQUEST,
        fetchRecentBulkPaymentLink
    );
    yield takeLatest(
        UPLOAD_BULK_PAYMENT_LINK_REQUEST,
        uploadBulkPaymentLinkFile
    );
    yield takeLatest(
        DOWNLOAD_BULK_PAYMENT_LINK_REQUEST,
        downloadBulkPaymentLinkFile
    );
}
